import { SharedFieldsService } from "@omnia/types"
import { AngularReactDialog, AngularReactDialogContext } from "../../../../../shared/react/reactAngularDialog"
import { IOmniaShell } from "../../../../../shared/shell"
import { IOmniaSession } from "../../../../../shared/types"
import { HoldingPermissionsApi } from "../api"
import { PermissionsDialog } from "./Dialog"
import { View } from "../state"

export function showEditDialog(shell: IOmniaShell) {

    return shell.showComponentAsDialog(PermissionsDialogConfig, undefined, { size: "xxlarge" })

}

const PermissionsDialogConfig: AngularReactDialog = {

    inject: {
        session: "OmniaSession",
        fieldSvc: "OmniaFieldsService"
    },

    component: DialogWrapper

}

function DialogWrapper({ dependencies, close }: AngularReactDialogContext) {

    const session: IOmniaSession = dependencies["session"]
    const fieldSvc: SharedFieldsService = dependencies["fieldSvc"]

    const view = session.getSeachParam("view") as View

    const api = new HoldingPermissionsApi(session, fieldSvc)

    return <PermissionsDialog
        api={api}
        close={close}
        initialView={view}
    />

}
